import React, { useRef} from 'react'
import styled from 'styled-components'
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom'

const Contact = () => {

    const ref = useRef(null);


    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end end"]
    })

    const scale = useTransform(scrollYProgress, [0, 1], [0, 1])
    const opacity = useTransform(scrollYProgress, [0, 1], [0, 1])
    const x = useTransform(scrollYProgress, [0.4, 1], ["-50%", "0%"])
    const y = useTransform(scrollYProgress, [0, 1], ["-100%", "0%"])

    return (
        <ContactDiv ref={ref}>

            <motion.div className="contactDiv" style={{y}}>
                <ContactHead>
                    <div>
                        <div className='firstHead'>

                            <div className="img">
                                <motion.img
                                    style={{
                                        opacity,
                                        scale
                                    }}
                                    src="My/me.jpg" alt="Myself" />
                            </div>
                            <motion.h2
                                style={{ scale, opacity }}
                                className='contactHead heading'>
                                Scribble your
                            </motion.h2>
                        </div>

                        <motion.h2
                            style={{ scale, opacity }}
                            className='contactHead heading'>
                            story ~!!
                        </motion.h2>
                    </div>
                </ContactHead>

                <ContactLine>

                    <div className='contactBox'>
                        <div className="line"></div>

                        <CircleDiv>

                            <motion.div
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                                style={{ x }}
                            >

                                <Link to={"/contact"} > Hit me up ! </Link>

                            </motion.div>

                        </CircleDiv>
                    </div>

                </ContactLine>

                <ContactInfo>

                    <div className="contactBox">

                        <ContactIcon>
                            <Link to={`mailto:gagan270903@gmail.com`}>
                                <span>
                                    gagan270903@gmail.com
                                </span>
                            </Link>
                        </ContactIcon>

                        <ContactIcon>
                            <Link to={`tel:+91 9026705339`}>
                                <span>
                                    +91 9026705339
                                </span>
                            </Link>
                        </ContactIcon>

                    </div>

                </ContactInfo>

            </motion.div>

            <div className="contactEnd">
                <span>
                    Created By Gagan. &#169; 2023
                </span>
            </div>
        </ContactDiv>
    )
}

export default Contact

const ContactIcon = styled(motion.div)`

    a{
        display: flex;
        padding: 1.5rem;
        border: 1px solid white;
        border-radius: 3rem;

        @media only screen and (max-width: 780px) {
            padding: 1rem !important;
        }

        span{
            font-size: 1rem;
        }
    }
`

const ContactInfo = styled(motion.div)`
    position: relative;
    @media only screen and (max-width: 780px) {
        margin-top: 4rem !important;
    }
    .contactBox{
        display: flex;
        gap: 2rem;

        @media only screen and (max-width: 570px) {
            flex-wrap:wrap;
        }
    }
`

const CircleDiv = styled(motion.div)`
    position : absolute !important;
    top: 0;
    right: 0;
    transform: translate(-50% , -50%);

    div{
        position: relative;
        a{
            background: var(--white2);
            width: 10rem;
            height: 10rem;
            display: flex;
            border-radius: 50%;
            font-size: 1.5rem;
            font-family: var(--font2);
            font-weight: 650;
            justify-content: center;
            align-items: center;
            color: var(--black1);

            @media only screen and (max-width: 780px) {
                width: 8rem !important;
                height: 8rem !important;
                font-size: 1rem !important;
            }

            @media only screen and (max-width: 570px) {
                width: 7rem !important;
                height: 7rem !important;
            }
            
            @media only screen and (max-width: 480px) {
                width: 6rem !important;
                height: 6rem !important;
            }
        }
    }
`

const ContactLine = styled(motion.div)`

    .contactBox{
        width: 100%;
        position: relative;

        .line{
            height: 1px;
            width: 100%;
            background: var(--white3);
        }
    }
`

const ContactHead = styled(motion.div)`
    display: flex;
    flex-diirection: column;
    position:relative;
    align-items: center;

    .firstHead{
        display: flex;
        gap: 2rem;
        align-items: center;
        
        @media only screen and (max-width: 570px) {
            gap: 1rem !important;
        }
        .img{
            height: 6em;
            width: 6em;

            @media only screen and (max-width: 570px) {
                height: 5em !important;
                width: 5em !important;
            }
            @media only screen and (max-width: 480px) {
                height: 3em !important;
                width: 3em !important;
            }
            
            img{
                border-radius: 50%;
                width: 100%;
                position:relative;
                height: 100%;
                object-fit: cover;
            }
        }

        h2{
            line-height: 2em;
            @media only screen and (max-width: 780px) {
                line-height: 3em !important;
            }
            
            @media only screen and (max-width: 570px) {
                line-height: 4rem !important;
                font-size: 3rem !important;
            }
            @media only screen and (max-width: 480px) {
                line-height: 5rem !important;
                font-size: 2.5rem !important;
            }
            @media only screen and (max-width: 430px) {
                font-size: 2rem !important;
            }
        }
    }

    h2{
        font-size: 6rem;
        font-family: var(--font2);
        color: white;
        position: relative;
        font-weight: 560;

        @media only screen and (max-width: 780px) {
            font-size: 3rem !important;
        }

        @media only screen and (max-width: 480px) {
            font-size: 2.5rem !important;
        }
        @media only screen and (max-width: 430px) {
            font-size: 2rem !important;
        }
    }
`

const ContactDiv = styled(motion.div)`
   
    background: var(--blackLight);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    
    .contactDiv{
        width: 70%;
        margin: auto;
        display: flex;
        gap: 5rem;
        justify-content: center;
        flex-direction: column;
        padding: 2rem;
        position: relative;
        
        @media only screen and (max-width: 780px) {
            padding: 1rem !important;
            width: 80% !important;
        }

    }

    .contactEnd{
        width: 70%;
        padding-bottom: 1rem;
        display: flex;
        justify-content: flex-end;

        span{
            font-size: 0.9rem;
            letter-sapcing: 1px;
            font-weight: 450;
            font-family: var(--font2);
        }
    }
`